import { render, staticRenderFns } from "./houseDetails.components.vue?vue&type=template&id=3c986117&scoped=true"
import script from "./houseDetails.components.vue?vue&type=script&lang=js"
export * from "./houseDetails.components.vue?vue&type=script&lang=js"
import style0 from "./houseDetails.components.vue?vue&type=style&index=0&id=3c986117&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c986117",
  null
  
)

export default component.exports